import React, { useMemo, useState } from "react";
import { SubHeader } from "../../Common/layout/SubHeader";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../../../_metronic/layout";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../../_metronic/_partials/controls";
import DynamicSimpleTable from "../../../util/DynamicSimpleReactTable";
import { errorMessage, formatActivity, formatDate, formatStatus, formatUsername, truncateString, ucFirst } from "../../../util/Helpers";
import cogoToast from "cogo-toast";
import { useGetBonusSharesHistoryQuery } from "../../../../redux/apiSlice";
import { Permission } from "../../Common/layout/Permission";
import { Permissions, PermissionType } from "../../../util/Permissions";
import ConfirmBonusSharePaymentModal from "./modals/ConfirmBonusSharePaymentModal";
import { SelectiveBonusSharesPayout } from "./SelectiveBonusSharesPayout";

export const BonusShareDetails = ({
    symbol,
    match: {
        params: {
            instrumentId,
            bonusShareId
        }
    }
}) => {
    const { data: bonusShares } = useGetBonusSharesHistoryQuery(instrumentId)

    const bonusShare = useMemo(() => {
        return bonusShares?.data?.find((bonusShareHistory) => bonusShareHistory.autoId === bonusShareId)
    }, [bonusShares, bonusShareId])

    /* Bonus Shares Modal State Management */
    const [payBonusSharesModal, setPayBonusSharesModal] = useState({ showConfirmBonusSharePaymentModal: false, details: null });

    /* Modal show/hide Toggle */
    const toggleModal = modal => _ => {
        setPayBonusSharesModal({ ...payBonusSharesModal, [modal]: !payBonusSharesModal[modal] })
    }

    return <>
        <div className="d-flex flex-column h-100">
            <SubHeader>
                <SubHeader.Nav>
                    <SubHeader.NavItem label={"Transaction History"} to={`/holdings/${instrumentId}/bonus-shares/${bonusShareId}/transactions`} />
                    <SubHeader.NavItem label={"Selective Bonus Share Payment"} to={`/holdings/${instrumentId}/bonus-shares/${bonusShareId}/selective-payment`} />
                </SubHeader.Nav>
            </SubHeader>

            <Switch>
                <Redirect exact={true} from="/holdings/:instrumentId/bonus-shares/:bonusShareId" to={`/holdings/:instrumentId/bonus-shares/${bonusShareId}/transactions`} />

                <ContentRoute path="/holdings/:instrumentId/bonus-shares/:bonusShareId/transactions" exact permission={Permissions.HOLDINGS}>
                    <div className="py-4 px-6 h-100">
                        <Card>
                            <CardHeader>
                                <div className="card-title py-5">
                                    <h3 className="card-label">
                                        <span className="d-block text-dark h3 mb-1 font-weight-bolder">{bonusShare?.qualificationDate}</span>
                                        <span className="d-block text-muted font-size-sm">{`${symbol || ""} - ${bonusShare?.quantity === undefined ? "" : bonusShare?.quantity} per ${bonusShare?.shareBasis === undefined ? "" : bonusShare?.shareBasis} share(s)`}</span>
                                    </h3>
                                </div>
                                <CardHeaderToolbar>
                                    <Permission permission={Permissions.HOLDINGS} permissionType={PermissionType.CREATE}>
                                        <button
                                            type="button"
                                            className={`btn btn-dark`}
                                            onClick={toggleModal("showConfirmBonusSharePaymentModal")}
                                        >
                                            Pay Unpaid Bonus Shares
                                        </button>
                                    </Permission>
                                </CardHeaderToolbar>
                            </CardHeader>
                            <CardBody>
                                <DynamicSimpleTable
                                    key={`${bonusShareId}-bonus-shares`}
                                    queryParams={
                                        `refId=${bonusShareId}`
                                        + `&limit=10`
                                        + `&liveData=true`
                                        + `&partner=sigma,zanibal,zanibal_ind`
                                    }
                                    searchBox={false}
                                    source={{ url: `/transactions` }}
                                    columns={[
                                        { title: "ACTIVITY", format: formatActivity },
                                        { title: "REFERENCE", format: row => truncateString(row.autoId, 18) },
                                        { title: "DESCRIPTION", key: "comment" },
                                        { title: "USER", format: row => formatUsername(row.userId, row.username, null, row.accountId, "transactions") },
                                        { title: "STATUS", format: row => formatStatus(ucFirst(row.tranStatus)) },
                                        { title: "PARTNER", format: row => ucFirst(row.partner) },
                                        { title: "CREATED AT", format: row => formatDate(row.created) },
                                        { title: "UPDATED AT", format: row => formatDate(row.created) },
                                    ]}
                                    onError={(err) =>
                                        cogoToast.error(errorMessage(err))
                                    }
                                    refreshIcon={true}
                                />
                            </CardBody>
                        </Card>
                    </div>
                </ContentRoute>
                <ContentRoute path="/holdings/:instrumentId/bonus-shares/:bonusShareId/selective-payment" exact permission={Permissions.HOLDINGS}>
                    <div className="py-4 px-6 h-100">
                        <SelectiveBonusSharesPayout
                            instrumentId={instrumentId}
                            symbol={symbol}
                            bonusShareId={bonusShareId}
                        />
                    </div>
                </ContentRoute>
            </Switch>
        </div>

        <ConfirmBonusSharePaymentModal
            {...payBonusSharesModal}
            bonusShareId={bonusShareId}
            qualificationDate={bonusShare?.qualificationDate}
            symbol={symbol}
            onHide={toggleModal("showConfirmBonusSharePaymentModal")}
        />
    </>
}